import { Component, Inject } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { SplashOptions } from "./splash-dialog";


@Component({
    selector: 'app-splash-dialog',
    templateUrl: './splash-dialog.component.html',
    styleUrls: ['./splash-dialog.component.scss'],
})
export class SplashDialogComponent {
    title: string | undefined;
    message: string | undefined;
    showProgress: boolean | undefined;

    constructor(public dialogRef: MatDialogRef<SplashDialogComponent>, @Inject(MAT_DIALOG_DATA) data: SplashOptions) {
        this.title = data.TitleText;
        this.message = data.MessageText;
        this.showProgress = data.ShowProgressBar ?? false;
    }
}